import loginDialog from "./loginDialog";
import register from "./register";
import changePwd from "./changePwd";
import changePhone from "./changePhone";

export default [loginDialog, register, changePwd, changePhone];
